import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expenses',
  templateUrl: './expenses.component.html',
  styleUrls: ['./expenses.component.css']
})
export class ExpensesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }



  VehicleTotal = [
    {
        "Vehicle": "Image",
        "VehicleType": "Mercedes Heavey Truck",
        "LicencePlate": "KA 01 MK 2008",
        "Date": "10-10-2018",
        "Amount": "SAR 5250"
    },{
      "Vehicle": "Image",
      "VehicleType": "Tata Truck",
      "LicencePlate": "MM 01 LL 8585",
      "Date": "10-10-2018",
      "Amount": "SAR 453266"
  },{
    "Vehicle": "Image",
    "VehicleType": "Mini Van",
    "LicencePlate": "KA 01 MK 2008",
    "Date": "10-10-2018",
    "Amount": "SAR 334"
},{
  "Vehicle": "Image",
  "VehicleType": "Mercedes Heavey Truck",
  "LicencePlate": "KA 01 MK 2008",
  "Date": "10-10-2018",
  "Amount": "SAR 43434"
}
  ]

  gridView = [
    {
        "Vehicle": "Image",
        "LicensePlate": "KA 01 MK 2008",
        "Date": "10-10-2018",
        "ExpenseType": "Insurance",
        "Amount": "SAR 250",
        "Notes": "Urgent renewal"       
    },
    {
      "Vehicle": "Image",
      "LicensePlate": "MA 00 KL 1585",
      "Date": "10-08-2018",
      "ExpenseType": "General Service",
      "Amount": "SAR 1022",
      "Notes": ""       
    },
    {
      "Vehicle": "Image",
      "LicensePlate": "WS 01 WW 1111",
      "Date": "07-01-2018",
      "ExpenseType": "Tyre Change",
      "Amount": "SAR 100",
      "Notes": "Front Tyre"       
    },
    {
      "Vehicle": "Image",
      "LicensePlate": "KA 01 MK 2008",
      "Date": "10-10-2018",
      "ExpenseType": "Insurance",
      "Amount": "SAR 250",
      "Notes": "Urgent renewal"       
  },
  {
    "Vehicle": "Image",
    "LicensePlate": "MA 00 KL 1585",
    "Date": "10-08-2018",
    "ExpenseType": "General Service",
    "Amount": "SAR 1022",
    "Notes": ""       
  },
  {
    "Vehicle": "Image",
    "LicensePlate": "WS 01 WW 1111",
    "Date": "07-01-2018",
    "ExpenseType": "Tyre Change",
    "Amount": "SAR 100",
    "Notes": "Front Tyre"       
  },  {
    "Vehicle": "Image",
    "LicensePlate": "KA 01 MK 2008",
    "Date": "10-10-2018",
    "ExpenseType": "Insurance",
    "Amount": "SAR 250",
    "Notes": "Urgent renewal"       
},
{
  "Vehicle": "Image",
  "LicensePlate": "MA 00 KL 1585",
  "Date": "10-08-2018",
  "ExpenseType": "General Service",
  "Amount": "SAR 1022",
  "Notes": ""       
},
{
  "Vehicle": "Image",
  "LicensePlate": "WS 01 WW 1111",
  "Date": "07-01-2018",
  "ExpenseType": "Tyre Change",
  "Amount": "SAR 100",
  "Notes": "Front Tyre"       
},  {
  "Vehicle": "Image",
  "LicensePlate": "KA 01 MK 2008",
  "Date": "10-10-2018",
  "ExpenseType": "Insurance",
  "Amount": "SAR 250",
  "Notes": "Urgent renewal"       
},
{
"Vehicle": "Image",
"LicensePlate": "MA 00 KL 1585",
"Date": "10-08-2018",
"ExpenseType": "General Service",
"Amount": "SAR 1022",
"Notes": ""       
},
{
"Vehicle": "Image",
"LicensePlate": "WS 01 WW 1111",
"Date": "07-01-2018",
"ExpenseType": "Tyre Change",
"Amount": "SAR 100",
"Notes": "Front Tyre"       
},
  ]

}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/fleet-management/expenses/expenses.component.ts